import { IError, userPlan } from '../../../../../common';
import { ObservableStore } from '../core/obvservable';

// IBasicErrorStoreData
export interface IBasicErrorStoreData {
    error: IError | Error;
    planWarning: userPlan.ILimitWarning;
}

/**
 * BasicErrorStore
 */
export class BasicErrorStore extends ObservableStore<IBasicErrorStoreData, BasicErrorStore> {

    // Error stack
    public stack: string;

    /**
     * Class conzstructor
     */
    public constructor(data?: IBasicErrorStoreData) {
        super(data ?? {
            error: null,
            planWarning: null,
        }, { deep: false })
    }

    /**
     * Set error
     * @param err 
     */
    public setError = (err: IError | Error, type = 'Error') => {
        if (err instanceof Error) this.stack = err.stack;

        this.mset({
            error: err
        })
    }

    /**
     * Error
     */
    public get error() {
        return this.data;
    }

    /**
     * Plan warning
     */
    public get planWarning() {
        return this.data.planWarning;
    }    

    /**
     * No error
     */
    public get isEmpty() {
        return !this.data.error;
    }

    /**
     * Has error
     */
    public get isError() {
        return !!this.data.error;
    }

    /**
     * Clear errors
     * @returns 
     */
    public clear = () => this.loadDefaults();
}